/* ── CART ── */
function openCart() {
  document.getElementById('cart-overlay').classList.add('open');
  document.getElementById('cart-drawer').classList.add('open');
  fetchCart();
}
function closeCart() {
  document.getElementById('cart-overlay').classList.remove('open');
  document.getElementById('cart-drawer').classList.remove('open');
}

/* Übersetzte Texte kommen aus window.jcT (layout/theme.liquid, Sprachdateien jc.js.*); %name% wird ersetzt */
function jcTr(key, fallback, vars) {
  let s = (window.jcT && window.jcT[key]) || fallback;
  if (vars) Object.keys(vars).forEach(k => { s = s.split('%' + k + '%').join(vars[k]); });
  return s;
}

function updateShippingBar(cart) {
  const wrap = document.getElementById('cart-ship');
  if (!wrap) return;
  const threshold = parseInt(wrap.dataset.threshold || '8000', 10);
  const msg  = document.getElementById('cart-ship-msg');
  const fill = document.getElementById('cart-ship-fill');
  const eu   = document.getElementById('cart-ship-eu');
  const total = cart ? cart.total_price : 0;
  const count = cart ? cart.item_count : 0;
  if (!count || !threshold) { wrap.style.display = 'none'; return; }
  wrap.style.display = 'block';
  if (fill) fill.style.width = Math.min(100, Math.round(total / threshold * 100)) + '%';
  if (total >= threshold) {
    wrap.classList.add('done');
    if (msg) msg.innerHTML = jcTr('free_unlocked_html', '🎉 <strong>Kostenloser Versand</strong> freigeschaltet!');
  } else {
    wrap.classList.remove('done');
    const remain = ((threshold - total) / 100).toFixed(2).replace('.', ',');
    if (msg) msg.innerHTML = jcTr('remaining_html', 'Nur noch <strong>%amount%</strong> bis zum kostenlosen Versand 🚚', { amount: jcMoney(threshold - total) });
  }
  if (eu) {
    const euThreshold = parseInt(eu.dataset.threshold || '11000', 10);
    if (total >= euThreshold) {
      eu.textContent = jcTr('eu_free', 'Auch Versand in die EU kostenlos ✓');
    } else {
      const euRemain = ((euThreshold - total) / 100).toFixed(2).replace('.', ',');
      eu.textContent = jcTr('eu_hint', 'Gilt für Deutschland · EU gratis ab %threshold% (noch %amount%)', { threshold: jcMoney(euThreshold).replace(/[,.]00(?=\D*$)/, ''), amount: jcMoney(euThreshold - total) });
    }
  }
}

function fetchCart() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => renderCart(cart))
    .catch(() => {});
}

function addToCart(variantId, productTitle, productVendor) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(r => r.json().then(data => ({ ok: r.ok, data: data })))
  .then(res => {
    if (!res.ok) {
      showToast(res.data.description || jcTr('in_cart_or_unavailable', 'Artikel ist bereits im Warenkorb oder nicht mehr verfügbar.'));
      return;
    }
    updateCartCount();
    showToast(jcTr('added', '%title% — hinzugefügt!', { title: productTitle || res.data.product_title }));
    fetchCart();
    openCart();
  })
  .catch(() => showToast(jcTr('add_error', 'Fehler beim Hinzufügen.')));
}
function buyNow(variantId) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(r => r.json().then(data => ({ ok: r.ok, data: data })))
  .then(res => {
    if (!res.ok) {
      showToast(res.data.description || jcTr('unavailable', 'Artikel ist nicht mehr verfügbar.'));
      return;
    }
    window.location.href = '/checkout';
  })
  .catch(() => showToast(jcTr('buy_error', 'Fehler beim Kauf.')));
}

function removeFromCart(line) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: line, quantity: 0 })
  })
  .then(r => r.json())
  .then(cart => {
    renderCart(cart);
    updateCartCount(cart.item_count);
  });
}

function updateCartCount(count) {
  if (count !== undefined) {
    document.querySelectorAll('#cart-count').forEach(el => el.textContent = count);
    return;
  }
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      document.querySelectorAll('#cart-count').forEach(el => el.textContent = cart.item_count);
    });
}

/* ERSETZT in assets/theme.js den kompletten Block
   von   function renderCart(cart) {
   bis direkt VOR   function checkout() {
*/

function jcMoney(cents) {
  return (cents / 100).toFixed(2).replace('.', ',') + ' €';
}

/* Rabatt je Artikel: Produktrabatte stehen direkt am Artikel,
   Bestellrabatte werden anteilig auf die Artikel verteilt. */
function jcLineDiscounts(cart) {
  const lines = cart.items.map(item => ({
    amount: item.original_line_price - item.final_line_price,
    title: ((item.line_level_discount_allocations || [])[0] || { discount_application: {} }).discount_application.title || ''
  }));
  const base = cart.items.reduce((s, item) => s + item.final_line_price, 0);
  if (base <= 0) return lines;
  (cart.cart_level_discount_applications || []).forEach(app => {
    let rest = app.total_allocated_amount;
    cart.items.forEach((item, i) => {
      const share = i === cart.items.length - 1
        ? rest
        : Math.round(app.total_allocated_amount * item.final_line_price / base);
      rest -= share;
      lines[i].amount += share;
      if (!lines[i].title) lines[i].title = app.title;
    });
  });
  return lines;
}

function updateCartSavings(cart) {
  const save = document.getElementById('cart-save');
  const saved = cart ? cart.total_discount : 0;
  if (save) {
    save.style.display = saved > 0 ? 'flex' : 'none';
    const orig = document.getElementById('cart-orig');
    const amt = document.getElementById('cart-saved');
    if (orig && cart) orig.textContent = jcMoney(cart.original_total_price);
    if (amt) amt.textContent = jcMoney(saved);
  }
  // Hinweis „Noch 1 Teil dazu …" – nur solange die Sale-Leiste im Header aktiv ist
  const upsell = document.getElementById('cart-upsell');
  if (upsell) {
    const bar = document.getElementById('jc-sale-bar');
    const text = bar ? bar.dataset.upsell : '';
    upsell.textContent = text || '';
    upsell.style.display = text && cart && cart.item_count === 1 ? 'block' : 'none';
  }
}

function renderCart(cart) {
  const el = document.getElementById('cart-items');
  const foot = document.getElementById('cart-foot');
  updateShippingBar(cart);
  updateCartSavings(cart);
  if (!el) return;
  if (!cart || cart.item_count === 0) {
    el.innerHTML = '<div class="cart-empty"><div class="cart-empty-icon">&#x1F6D2;</div><p>' + jcTr('cart_empty', 'Dein Warenkorb ist leer.') + '</p></div>';
    if (foot) foot.style.display = 'none';
    return;
  }
  if (foot) foot.style.display = 'block';
  const totalEl = document.getElementById('cart-total');
  if (totalEl) totalEl.textContent = jcMoney(cart.total_price);
  const disc = jcLineDiscounts(cart);
  el.innerHTML = cart.items.map((item, i) => {
    const d = disc[i];
    const price = d.amount > 0
      ? `<s class="ci-price-old">${jcMoney(item.original_line_price)}</s><span class="ci-price-new">${jcMoney(item.original_line_price - d.amount)}</span>`
      : jcMoney(item.original_line_price);
    return `
    <div class="cart-item">
      <div class="ci-img"><img src="${item.image}" alt="${item.product_title}"></div>
      <div class="ci-info">
        <div class="ci-brand">${item.vendor || ''}</div>
        <div class="ci-name">${item.product_title}</div>
        <div class="ci-size">${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
        <div class="ci-price">${price}</div>
        ${d.amount > 0 && d.title ? `<div class="ci-disc">🏷 ${d.title}</div>` : ''}
      </div>
      <button class="ci-remove" onclick="removeFromCart(${i + 1})" aria-label="${jcTr('remove', 'Entfernen')}">&#x2715;</button>
    </div>`;
  }).join('');
}



function checkout() {
  window.location.href = '/checkout';
}

/* ── FAQ ── */
function toggleFaq(btn) {
  const a = btn.nextElementSibling;
  const open = a.classList.toggle('open');
  btn.classList.toggle('open', open);
}

/* ── FILTERS (Collection page) ── */
let activeFilters = { brand: 'all', type: 'all', size: 'all', condition: 'all', color: 'all' };
let searchQuery = '';

const PRODUCTS_PER_PAGE = 33;
let productPage = 1;

function setFilter(type, val, el) {
  activeFilters[type] = val;
  const row = el.closest('.filter-row');
  row.querySelectorAll('.fbtn').forEach(b => b.classList.remove('active'));
  el.classList.add('active');
  applyFilters();
}
/* Liest Filtertyp und -wert aus den data-Attributen des Buttons.
   So kommen Werte wie "Levi's" (mit Apostroph) nicht mehr in einen
   Inline-JS-String und können den onclick-Handler nicht mehr zerbrechen. */
function setFilterFromEl(el) {
  setFilter(el.dataset.filterType, el.dataset.filterVal, el);
}

/* Filter-Gruppe auf-/zuklappen */
function toggleFilterGroup(head) {
  const group = head.closest('.filter-group');
  if (!group) return;
  const isOpen = group.classList.toggle('open');
  head.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
}

/* Im eingeklappten Kopf die aktuelle Auswahl anzeigen (z.B. "Levi's") */
function refreshFilterHeads() {
  document.querySelectorAll('.filter-group').forEach(group => {
    const current = group.querySelector('.filter-current');
    if (!current) return;
    const active = group.querySelector('.filter-row .fbtn.active');
    const label = active ? active.textContent.trim() : '';
    current.textContent = (label && label.toLowerCase() !== 'alle') ? '— ' + label : '';
  });
}

function restoreFiltersFromURL() {
  const params = new URLSearchParams(window.location.search);
  let any = false;
  ['brand', 'type', 'size', 'condition', 'color'].forEach(k => {
    const v = params.get(k);
    if (v) { activeFilters[k] = v.toLowerCase(); any = true; }
  });
  if (!any) return;
   document.querySelectorAll('.filter-row .fbtn').forEach(b => {
    const key = b.dataset.filterType;
    if (!key) return;
    const val = (b.dataset.filterVal || '').toLowerCase();
    b.classList.toggle('active', val === activeFilters[key]);
  });
  applyFilters();
  const shopEl = document.getElementById('main-collection') || document.getElementById('shop');
  if (shopEl) shopEl.scrollIntoView();
}

// Vereinheitlicht Text für die Suche: macht klein und ersetzt Trennzeichen
// (| / \ – — - _ , . : ( ) [ ]) durch Leerzeichen, damit z.B.
// "Fred Perry Polo Schwarz" den Titel "Fred Perry Polo | Schwarz | Gr. L" findet.
function jcNormalize(s) {
  return (s || '')
    .toLowerCase()
    .replace(/[|\/\\–—_,.:()\[\]-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function cardMatchesFilters(card) {
  const brand = card.dataset.brand || '';
  const type = card.dataset.type || '';
  const tags = (card.dataset.tags || '').replace(/:\s+/g, ':');
  const nameEl = card.querySelector('.pc-name');
  const nameText = nameEl ? nameEl.textContent : '';
  // Durchsuchbarer Text ohne Trennzeichen; jedes Suchwort muss vorkommen.
  const haystack = jcNormalize(brand + ' ' + type + ' ' + nameText + ' ' + (card.dataset.tags || ''));
  const queryWords = searchQuery ? searchQuery.split(' ').filter(Boolean) : [];
  const matchesSearch = queryWords.length === 0 || queryWords.every(w => haystack.includes(w));
  return matchesSearch &&
    (activeFilters.brand === 'all' || brand.replace(/[^a-z0-9]/gi, '').toLowerCase() === activeFilters.brand.replace(/[^a-z0-9]/gi, '').toLowerCase()) &&
    (activeFilters.type === 'all' || type === activeFilters.type.toLowerCase()) &&
    (activeFilters.size === 'all' || tags.includes('size:' + activeFilters.size.toLowerCase())) &&
    (activeFilters.condition === 'all' || tags.includes('condition:' + activeFilters.condition.toLowerCase())) &&
    (activeFilters.color === 'all' || tags.includes('color:' + activeFilters.color.toLowerCase()));
}

function applyFilters() {
  productPage = 1;
  renderProductPage();
  refreshFilterHeads();
}

function filterBySearch(val) {
  searchQuery = jcNormalize(val);
  applyFilters();
}

function renderProductPage() {
  const cards = Array.from(document.querySelectorAll('.product-card[data-brand]'));
  if (cards.length === 0) return;
  const matching = cards.filter(cardMatchesFilters);

  const pagEl = document.getElementById('jc-pagination');
  // Desktop/Tablet (ab 768px): alle Produkte in einem scrollbaren Grid – keine Seiten, keine Lücken.
  // Handy (unter 768px): wie bisher 33 Produkte pro Seite.
  const usePagination = !!pagEl && !window.matchMedia('(min-width: 768px)').matches;

  if (usePagination) {
    const totalPages = Math.max(1, Math.ceil(matching.length / PRODUCTS_PER_PAGE));
    if (productPage > totalPages) productPage = totalPages;
    if (productPage < 1) productPage = 1;
    const start = (productPage - 1) * PRODUCTS_PER_PAGE;
    const pageCards = matching.slice(start, start + PRODUCTS_PER_PAGE);
    cards.forEach(c => { c.style.display = 'none'; });
    pageCards.forEach(c => { c.style.display = ''; });
    renderPagination(totalPages);
  } else {
    cards.forEach(c => {
      if (cardMatchesFilters(c)) {
        c.style.display = '';
        c.classList.add('visible'); // sicher sichtbar machen (Fade-In-Effekt greift bei umgeschalteten Karten nicht)
      } else {
        c.style.display = 'none';
      }
    });
    if (pagEl) pagEl.innerHTML = '';
  }

  const countEl = document.getElementById('prod-count');
  if (countEl) countEl.textContent = matching.length + ' Artikel';
}

// Wechsel Handy <-> Desktop (Fenster verkleinern/vergrößern, Gerät drehen): Grid neu aufbauen
window.matchMedia('(min-width: 768px)').addEventListener('change', function () {
  productPage = 1;
  renderProductPage();
});

function goToProductPage(p) {
  productPage = p;
  renderProductPage();
  const shopEl = document.getElementById('main-collection') || document.getElementById('shop');
  if (shopEl) shopEl.scrollIntoView({ behavior: 'smooth' });
}

function renderPagination(totalPages) {
  const wrap = document.getElementById('jc-pagination');
  if (!wrap) return;
  if (totalPages <= 1) { wrap.innerHTML = ''; return; }
  let html = '';
  if (productPage > 1) {
    html += '<button class="fbtn" aria-label="' + jcTr('prev_page', 'Vorherige Seite') + '" onclick="goToProductPage(' + (productPage - 1) + ')">&lsaquo;</button>';
  }
  for (let i = 1; i <= totalPages; i++) {
    html += '<button class="fbtn' + (i === productPage ? ' active' : '') + '" onclick="goToProductPage(' + i + ')">' + i + '</button>';
  }
  if (productPage < totalPages) {
    html += '<button class="fbtn" aria-label="' + jcTr('next_page', 'Nächste Seite') + '" onclick="goToProductPage(' + (productPage + 1) + ')">&rsaquo;</button>';
  }
  wrap.innerHTML = html;
}

function setFilterFromBrand(brand) {
  activeFilters.brand = brand;
  document.querySelectorAll('.filter-row').forEach(row => {
    const label = row.querySelector('.filter-label');
    if (label && label.textContent.trim() === 'MARKE') {
      row.querySelectorAll('.fbtn').forEach(b => {
        b.classList.remove('active');
        if (b.dataset.filterVal === brand) b.classList.add('active');
      });
    }
  });
  const shopEl = document.getElementById('shop') || document.getElementById('main-collection');
  if (shopEl) shopEl.scrollIntoView({ behavior: 'smooth' });
  applyFilters();
}

/* ── MOBILE NAV ── */
function openMobileNav() {
  const nav = document.getElementById('mobile-nav');
  if (nav) nav.classList.add('open');
}
function closeMobileNav() {
  const nav = document.getElementById('mobile-nav');
  if (nav) nav.classList.remove('open');
}

/* ── PRODUCT GALLERY ── */
function switchImage(img, thumb) {
  const mainImg = document.getElementById('product-main-img');
  if (mainImg) mainImg.src = img;
  document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
  if (thumb) thumb.classList.add('active');
}

/* ── NEWSLETTER ── */
function subscribe() {
  const input = document.getElementById('nl-input');
  if (input && input.value && input.value.includes('@')) {
    showToast(jcTr('subscribed', 'Angemeldet! ✓'));
    input.value = '';
  } else {
    showToast(jcTr('email_invalid', 'Bitte gültige E-Mail eingeben.'));
  }
}

/* ── TOAST ── */
function showToast(msg) {
  const t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(() => t.classList.remove('show'), 2800);
}

/* ── INIT ── */
document.addEventListener('DOMContentLoaded', () => {
  updateCartCount();
  const countEl = document.getElementById('prod-count');
  if (countEl && !countEl.dataset.total) {
    const total = document.querySelectorAll('.product-card[data-brand]').length;
    countEl.textContent = total + ' Artikel';
  }
  if (document.getElementById('jc-pagination')) renderProductPage();
});
// Brand filter from URL parameter
document.addEventListener('DOMContentLoaded', function() {
  var params = new URLSearchParams(window.location.search);
  var brand = params.get('brand');
  if (brand) {
    var btns = document.querySelectorAll('.filter-row .fbtn');
    btns.forEach(function(btn) {
      var row = btn.closest('.filter-row');
      var label = row.querySelector('.filter-label');
      if (label && label.textContent.trim() === 'MARKE') {
        if (btn.textContent.trim().toLowerCase() === brand.toLowerCase()) {
          btn.click();
        }
      }
    });
  }
});
// Scroll Fade-In
const observer = new IntersectionObserver((entries) => {
  entries.forEach(el => {
    if(el.isIntersecting){
      el.target.classList.add('visible');
      observer.unobserve(el.target);
    }
  });
}, { threshold: 0.12 });

document.querySelectorAll(
  '.drop-card, .product-card, .brand-card, .trust-item, .review-card, .pc-img img, .drop-img img'
).forEach(el => {
  el.classList.add('fade-in');
  observer.observe(el);
});
function toggleAccordion(btn) {
  const body = btn.nextElementSibling;
  const isOpen = btn.classList.contains('open');
  // alle schließen
  document.querySelectorAll('.accordion-trigger').forEach(b => {
    b.classList.remove('open');
    b.nextElementSibling.classList.remove('open');
  });
  // dieses öffnen wenn vorher geschlossen
  if (!isOpen) {
    btn.classList.add('open');
    body.classList.add('open');
  }
}

var galleryIndex = 0;

function switchImageIndex(index, thumb) {
  galleryIndex = index;
  document.getElementById('product-main-img').src = galleryImages[index];
  document.querySelectorAll('.product-thumb').forEach(function(t) { t.classList.remove('active'); });
  if (thumb) thumb.classList.add('active');
}

function galleryNext() {
  var thumbs = document.querySelectorAll('.product-thumb');
  galleryIndex = (galleryIndex + 1) % galleryImages.length;
  switchImageIndex(galleryIndex, thumbs[galleryIndex]);
}

function galleryPrev() {
  var thumbs = document.querySelectorAll('.product-thumb');
  galleryIndex = (galleryIndex - 1 + galleryImages.length) % galleryImages.length;
  switchImageIndex(galleryIndex, thumbs[galleryIndex]);
}
/* ── COLLECTION: restliche Seiten nachladen (skaliert über 250 Produkte) ── */
async function jcLoadRemaining() {
  const grid = document.querySelector('.product-grid[data-total-pages]');
  if (!grid) return;
  const totalPages = parseInt(grid.getAttribute('data-total-pages') || '1', 10);
  const baseUrl = grid.getAttribute('data-collection-url') || '';
  if (!baseUrl || totalPages < 2) return;
  for (let p = 2; p <= totalPages; p++) {
    try {
      const sep = baseUrl.indexOf('?') === -1 ? '?' : '&';
      const res = await fetch(baseUrl + sep + 'page=' + p);
      if (!res.ok) continue;
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const cards = doc.querySelectorAll('.product-grid .product-card');
      const frag = document.createDocumentFragment();
      cards.forEach(c => frag.appendChild(document.importNode(c, true)));
      grid.appendChild(frag);
    } catch (e) { /* Seite überspringen */ }
  }
}
